const initialState = {
  entryFields: [],
  entryName: '',
  entries: [],
  entry: null,
  drawerEntry: null,
  loading: false,
  success: false,
  error: null,
  isSaved: false,
  entryData: '',
  entryContentTypePreviewUrl: ''
};

const entryReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FORM_SUBMISSION_REQUEST':
      return {
        ...state,
        loading: true,
        success: false
      };
    case 'FORM_SUBMISSION_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
        isSaved: true,
        entryData: action.payload
      };
    case 'FORM_SUBMISSION_FAILURE':
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case "GET_CONTENT_TYPE_FOR_ENTRY":
      return {
        ...state,
        entryFields: action.payload.fields,
        entryName: action.payload.name,
        entryContentTypePreviewUrl: action.payload.previewUrl
      };
    case "GET_ALL_ENTRIES":
      return {
        ...state,
        entries: action.payload.entries,
      };
    case "GET_SINGLE_ENTRY":
      return {
        ...state,
        entry: action.payload.entry,
        isSaved: false
      };
    case "GET_ENTRY_FOR_DRAWER":
      return {
        ...state,
        drawerEntry: action.payload.entry,
        isSaved: false
      };
    case "GET_ENTRY_VERSIONS":
      if (!state.entry) return state;
      return {
        ...state,
        entry: {
          ...state.entry,
          entry: {
            ...state.entry.entry,
            versionData: action.payload.entryVersionData,
            version: action.payload.currentVersion
          },
          localeContent: state.entry.localeContent?.map(lc => {
            const lv = action.payload.localeVersionData[lc._id];
            return lv ? { ...lc, versionData: lv.versionData } : lc;
          })
        }
      };
    case "UPDATE_FIELD":
      const updatedFields = state.fields.map((field, idx) =>
        idx === action.payload.index
          ? { ...field, ...action.payload.fieldData }
          : field
      );
      return { ...state, fields: updatedFields };

    case "RESET_FORM":
      return initialState;
    case "GET_CONTENT_TYPES":
      return {
        ...state,
        contentTypes: action.payload,
        isSaved: false
      };
    case "DELETE_ENTRY":
      return {
        ...state,
        entries: state.entries.filter(entry => entry._id !== action.payload),
      }
    default:
      return state;
  }
};

export default entryReducer;
